export interface TranslatedValidationError {
  interpolationVariables: Record<string, string | number>
  key: string
}

export const isTranslatedValidationError = (
  data: unknown,
): data is TranslatedValidationError => {
  if (!data || !(data instanceof Object)) {
    return false
  }

  const maybeTranslatedValidationError = data as TranslatedValidationError

  if (typeof maybeTranslatedValidationError?.key !== "string") {
    return false
  }

  if (
    !(maybeTranslatedValidationError?.interpolationVariables instanceof Object)
  ) {
    return false
  }

  const interpolationVariableKeys = Object.keys(
    maybeTranslatedValidationError.interpolationVariables,
  )

  return interpolationVariableKeys.every(key => {
    const variableType = typeof maybeTranslatedValidationError
      .interpolationVariables[key]
    return variableType === "string" || variableType === "number"
  })
}
